import { useCallback, useMemo, useState } from 'react';

type PropsType = {
  increment: number;
  minCount?: number;
  maxCount?: number;
};

export const useIncrementCount = (props: PropsType) => {
  const { increment, minCount, maxCount } = props;

  const [count, setCount] = useState(minCount ?? 0);

  const increase = useCallback(() => {
    setCount((count) => {
      return typeof maxCount === 'undefined' || count < maxCount
        ? count + 1
        : count;
    });
  }, [setCount, maxCount]);

  const decrease = useCallback(() => {
    setCount((count) => {
      return typeof minCount === 'undefined' || count > minCount
        ? count - 1
        : count;
    });
  }, [setCount, minCount]);

  const { minValue, maxValue } = useMemo(() => {
    return {
      minValue: !!minCount ? increment * minCount : undefined,
      maxValue: !!maxCount ? increment * maxCount : undefined,
    };
  }, [increment, minCount, maxCount]);

  return {
    value: count * increment,
    minValue,
    maxValue,
    increase,
    decrease,
    count,
    setCount,
  };
};
